var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.edf,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}}),_c('div',{staticClass:"relative z-0"},[_c('hotspot-richmedia',{staticClass:"bottom-10 left-2",attrs:{"options":{
                    icon: 'diaporama',
                    collection: _vm.getRichmediaByCollection(
                        _vm.currentPage,
                        'L’ingénierie hydraulique, championne de la flexibilité'
                    ),
                }}})],1)],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-selective_green',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.alt)}}),_c('h3',{staticClass:"text-xl lg:text-2xl 2xl:text-4xl",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.title)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"-top-4 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    "Fonctionnement d’une STEP"
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-sushi',
                        }}},[_c('p',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}})]),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content_01
                                .text
                        )}}),_c('router-link',{staticClass:"text-nandor 2xl:text-lg",attrs:{"to":{
                            name: 'catalogue',
                            params: { slug: 'page-015' },
                        }},domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content_03
                                .text
                        )}}),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content_02
                                .text
                        )}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-sushi',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Title.text
                            )}})]),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphTwo_Content.text
                        )}})],1),_c('div',{staticClass:"card",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        "XFLEX HYDRO : démonstrateur de Vogelgrun"
                                    ),
                                }}})],1),_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage2.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage2
                                            .alt,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage2
                                            .text,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                                fontSize: 'text-xs',
                            }}}),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }}},[_c('Triangles',{attrs:{"options":{
                                    colors: [
                                        '#81C341',
                                        '#B7DD92',
                                        '#cce5a4' ],
                                    direction: 'top',
                                }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content
                                        .sParagraphThree_Title.text
                                )}})],1)],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphThree_Content.text
                        )}})]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative mt-4"},[_c('hotspot-richmedia',{staticClass:"-top-6 right-2 md:top-2 md:-mr-8 lg:mr-0 lg:-top-5 xl:-top-6",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    "SoFLEX’hy : expériences sur la Durance"
                                ),
                            }}})],1),_c('div',{staticClass:"relative mt-4"},[_c('hotspot-richmedia',{staticClass:"-top-6 right-16 md:top-2 md:-mr-8 lg:mr-0 lg:-top-5 xl:-top-6",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    "SoFLEX’hy: présentation"
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"card",staticStyle:{"padding-top":"0"}},[_c('article-note',{staticClass:"eliminate-margin",attrs:{"options":{
                            verticalcontent:
                                _vm.currentPage.content.sParagraphFive_Title
                                    .text,
                            content:
                                _vm.currentPage.content.sParagraphFive_Content
                                    .text,
                            color: {
                                verticalcontent: 'text-cornflower_blue',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                verticalcontent: 'text-2xl 2xl:text-3xl',
                                content: '',
                            },
                        }}})],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }